/**
 * Trail Map — Legend interaction and fullscreen toggle.
 *
 * Listens for the 'dclt-map-ready' event dispatched by leaflet-init.js,
 * then wires up legend item clicks to pan/zoom the map and open popups,
 * and the fullscreen button to toggle the map's fullscreen state.
 *
 * @package DCLT
 */

( function () {
	'use strict';

	function initTrailMapUI( block ) {
		var mapEl = block.querySelector( '[data-trail-map]' );
		if ( ! mapEl ) return;

		function setup( map, markerMap ) {
			// ── Legend item clicks ──
			var legendItems = block.querySelectorAll( '.dclt-trail-map__legend-item' );

			legendItems.forEach( function ( btn ) {
				btn.addEventListener( 'click', function () {
					var trailId = btn.getAttribute( 'data-trail-id' );
					var lat = parseFloat( btn.getAttribute( 'data-lat' ) );
					var lng = parseFloat( btn.getAttribute( 'data-lng' ) );
					var marker = markerMap[ trailId ];

					if ( marker ) {
						map.once( 'moveend', function () {
							marker.openPopup();
						} );
						map.setView( [ lat, lng ], 16, { animate: true } );
					}
				} );
			} );

			// ── Fullscreen toggle ──
			var fullscreenBtn = block.querySelector( '.dclt-trail-map__fullscreen' );
			if ( fullscreenBtn ) {
				fullscreenBtn.addEventListener( 'click', function () {
					var mapContainer = mapEl;

					if ( document.fullscreenElement === mapContainer ) {
						document.exitFullscreen();
					} else if ( mapContainer.requestFullscreen ) {
						mapContainer.requestFullscreen();
					}
				} );

				// Invalidate map size when entering/exiting fullscreen.
				document.addEventListener( 'fullscreenchange', function () {
					// Small delay to let the browser finish the transition.
					setTimeout( function () {
						map.invalidateSize();
					}, 100 );
				} );
			}
		}

		// If the map is already initialized (leaflet-init.js loaded first).
		if ( mapEl._leafletMap ) {
			setup( mapEl._leafletMap, mapEl._markerMap || {} );
			return;
		}

		// Otherwise wait for the custom event.
		mapEl.addEventListener( 'dclt-map-ready', function ( e ) {
			setup( e.detail.map, e.detail.markers );
		} );
	}

	function init() {
		document.querySelectorAll( '.dclt-trail-map' ).forEach( initTrailMapUI );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
